module.exports = __webpack_public_path__ + "img/2.79aac74d.jpg";